import { databasePasswordAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";
import { ibmDb2ForIConnectionString } from "./shared";

export const ibmDb2ForI = defineConnector({
  identifier: "ibmDb2ForI",
  name: "IBM Db2 for i",
  tagLine: "Run queries against Db2 on IBM i",
  keywords: "db2 db2 for i ibm i as400 as/400 database sql relational",
  logo,
  tags: ["data"],
  protocol: "db2",
  connectionTest: {
    protocol: "db2",
    connectionString: ibmDb2ForIConnectionString,
  },
  defaultUrlPattern: () => "",
  customizeStepHandledInline: true,
  auth: (app) => databasePasswordAuth(app.secret.password),
  steps: [
    {
      title: "Enter your IBM Db2 for i connection",
      items: [
        {
          kind: "input",
          label: "Name",
          required: true,
          defaultValue: "IBM Db2 for i",
          target: { kind: "connectedApp", field: "name" },
        },
        {
          kind: "input",
          label: "Host",
          required: true,
          placeholder: "ibmi.example.com",
          target: { kind: "configuration", field: "host" },
        },
        {
          kind: "input",
          label: "Port",
          required: true,
          placeholder: "446 or 448",
          helperText: "Use port 446 without TLS or port 448 with TLS.",
          target: { kind: "configuration", field: "port" },
        },
        {
          kind: "input",
          label: "Relational database name",
          required: true,
          placeholder: "MYRDB",
          helperText:
            "The relational database directory entry configured on IBM i.",
          target: { kind: "configuration", field: "database" },
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          target: { kind: "configuration", field: "username" },
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
        {
          kind: "select",
          label: "TLS",
          required: true,
          defaultValue: "true",
          options: [
            { label: "Enabled", value: "true" },
            { label: "Disabled", value: "false" },
          ],
          target: { kind: "configuration", field: "tls" },
        },
        {
          kind: "file",
          label: "CA certificate",
          accept: ".pem,.crt,.cer",
          helperText:
            "Upload a PEM CA certificate for a private or self-signed IBM i server.",
          target: { kind: "configuration", field: "tlsCaCertificate" },
          visibleWhen: [
            {
              target: { kind: "configuration", field: "tls" },
              value: "true",
            },
          ],
        },
      ],
    },
  ],
  publicEnvVars: (configuration) => ({
    DB2_URL: ibmDb2ForIConnectionString(configuration),
  }),
  usageHint: () =>
    "Use process.env.DB2_URL as the IBM Db2 for i connection string.",
});
